import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function GibraltarFundsAssetManagementLicense() {

    return (
        <main className='main'>
            <IntroSection
                title="Gibraltar Funds & Asset Management License"
                subtitle="A Gateway to UK & Global Investors"
                description="Gibraltar has emerged as a leading fund jurisdiction, offering flexible fund structures under the GFSC while maintaining a low-tax, business-friendly regime. With Experienced Investor Funds (EIFs) as the flagship structure, Gibraltar is an ideal base for hedge funds, private equity, venture capital, and digital asset funds."
                badges={[
                    "EIFs",
                    "Private Funds",
                    "UCITS-Equivalent",
                    "Fund Managers"
                ]}
                buttonText="Request a Gibraltar Funds Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/gibraltar-funds-asset-management-license-hero.png")}
                imageAlt=""
            />


            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Gibraltar for Funds?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "UK Market Access",
                                                text: "Gibraltar funds can market directly in the UK."
                                            },
                                            {
                                                title: "Respected Regulator",
                                                text: "GFSC ensures investor protection."
                                            },
                                            {
                                                title: "EIF Model",
                                                text: "Fast-track setup for professional investors."
                                            },
                                            {
                                                title: "Crypto & Digital Asset Funds",
                                                text: "Gibraltar is DLT/crypto friendly."
                                            },
                                            {
                                                title: "Tax Efficiency",
                                                text: "10% corporate tax, no VAT, no capital gains."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Fund Structures in Gibraltar"
                        blocks={[
                            {
                                title: "Experienced Investor Fund (EIF)",
                                items: [
                                    { text: "Most popular structure, designed for sophisticated/professional investors." },
                                    { text: "Flexible asset classes (hedge, VC, crypto, private equity)." },
                                    { text: "Fast approval process — sometimes within weeks." }
                                ]
                            },
                            {
                                title: "Private Funds",
                                items: [
                                    { text: "For fewer than 50 investors." },
                                    { text: "Often used by family offices or closed groups." }
                                ]
                            },
                            {
                                title: "UCITS-Equivalent Funds",
                                items: [
                                    { text: "EU-style retail funds for wider distribution." },
                                    { text: "Higher compliance requirements." }
                                ]
                            },
                            {
                                title: "Fund Manager & Administrator Licenses",
                                items: [
                                    { text: "Separate licenses for portfolio managers, investment advisors, and administrators." },
                                    { text: "Required for managing or servicing funds." }
                                ]
                            }
                        ]}
                    />


                    <LocationTimeline
                        title="Capital & Requirements"
                        item={
                            [
                                {
                                    title: "EIFs Capital Requirement",
                                    text: "Typically EUR 100,000+ subscribed capital."
                                },
                                {
                                    title: "Fund Managers Capital",
                                    text: "EUR 125,000–350,000 depending on scope."
                                },
                                {
                                    title: "Entity Requirement",
                                    text: "Gibraltar company or limited partnership required."
                                },
                                {
                                    title: "Resident Presence",
                                    text: "Local directors and compliance officer required."
                                },
                                {
                                    title: "Custodian",
                                    text: "Required for EIFs and UCITS funds."
                                },
                                {
                                    title: "Audit",
                                    text: "Annual audits mandatory."
                                }
                            ]

                        }
                    />

                    <ServiceCards
                        title='Benefits of Gibraltar Fund Licensing'
                        services={
                            [
                                {
                                    title: "Direct UK Access",
                                    text: "Post-Brexit advantage for UK investors."
                                },
                                {
                                    title: "Tier-1 Reputation",
                                    text: "Regulated by GFSC, recognized globally."
                                },
                                {
                                    title: "Crypto Funds Welcome",
                                    text: "EIFs can include digital assets and blockchain strategies."
                                },
                                {
                                    title: "Flexible & Fast",
                                    text: "EIFs approved more quickly than Malta or Luxembourg funds."
                                },
                                {
                                    title: "Tax Advantages",
                                    text: "Low corporate tax, no capital gains."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Pre-Application Consultation",
                                    text: "Choose fund type (EIF, Private, UCITS)."
                                },
                                {
                                    title: "Entity Incorporation",
                                    text: "Gibraltar company or limited partnership setup."
                                },
                                {
                                    title: "Application Preparation",
                                    text: "Prepare prospectus, compliance documents, and AML/KYC manuals."
                                },
                                {
                                    title: "GFSC Review",
                                    text: "Regulator conducts due diligence on managers and fund promoters."
                                },
                                {
                                    title: "Approval & Launch",
                                    text: "EIFs can be launched in weeks; other funds typically 3–6 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "EIFs",
                                    description: "weeks to a few months."
                                },
                                {
                                    name: "Other Funds",
                                    description: "3–6 months."
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from GBP 60,000+."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "compliance, custodian, GFSC fees, audits."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [

                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a hedge fund, private fund, or EIF?"
                        description="Gibraltar offers Tier-1 fund structures with UK access, regulated by the GFSC."
                        buttonText="Book a Gibraltar Fund Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const testimonialsData = [
    {
        quote: "We launched a Gibraltar EIF focused on crypto assets. Offshore Advisory managed the structure and GFSC process.",
        author: "James P.",
        role: "Fund Manager"
    },
    {
        quote: "Our private equity fund chose Gibraltar for UK access. Offshore Advisory guided us from incorporation to launch.",
        author: "Natalia K.",
        role: "Investor"
    }
];

const faqData = [
    {
        question: "What is an EIF?",
        content: [
            { type: "answer", text: "A fast-track Experienced Investor Fund, only for professional investors." },
        ],
    },
    {
        question: "Can Gibraltar funds invest in crypto?",
        content: [
            { type: "answer", text: "Yes — EIFs are digital asset friendly." },
        ],
    },
    {
        question: "Is a custodian required?",
        content: [
            { type: "answer", text: "Yes, for EIFs and UCITS-equivalent funds." },
        ],
    },
    {
        question: "Why Gibraltar over Malta?",
        content: [
            { type: "answer", text: "Gibraltar offers UK access, faster EIF approvals, and strong crypto regulation." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "EIFs: weeks; UCITS/private funds: 3–6 months." },
        ],
    },
];

